import React, { useState } from 'react'
import Select from 'react-select';
import MachineCard from '../MachineCard'
import {
    Row,
    Col, 
 } from 'reactstrap';


function Index() {
    const [selectedOne, setSelectedOne] = useState("");
    const [selectedTwo, setSelectedTwo] = useState("");
    const [isShow, setIsShow] = useState(false);

    const optionsOne = [
        { value: "castIron", label: "Cast Iron" },
        { value: "aluminium", label: "Aluminium" },
        { value: "highAlloySteel", label: "High Alloy Steel  / Stainless Steel" },
        { value: "yellowMetal", label: "Yellow Metal" },
        { value: "lowAlloySteel", label: "Low/Med Alloy Steel" },
        { value: "otherAlloys", label: "Other Alloys" },
    ];
    const optionsTwo = [
        { value: "broaching", label: "Broaching" },
        { value: "deepDrilling", label: "Deep Drilling" },
        { value: "grinding", label: "Grinding" },
        { value: "milling", label: "Milling" },
        { value: "drilling", label: "Drilling" },
        { value: "superfinishing", label: "Superfinishing" },
    ];
    
    const changeSelectedOne = (value) => {
        setSelectedOne(value.value);
    }
    const changeSelectedTwo = (value) => {
        setSelectedTwo(value.value);
        setIsShow(true);
    }

    let card;
    if(selectedOne==="castIron"){
        if(selectedTwo==="broaching"){
            card = <MachineCard
                    firstTitle = "Cast Iron"
                    secondTitle = "Broaching"
               />
        } else if(selectedTwo==="deepDrilling") {
            card = <MachineCard
                    firstTitle = "Cast Iron"
                    secondTitle = "Deep Drilling"
               />
        } else if(selectedTwo==="grinding") {
            card = <MachineCard
                    firstTitle = "Cast Iron"
                    secondTitle = "Grinding"
               />
        } else if(selectedTwo==="milling") {
            card = <MachineCard
                    firstTitle = "Cast Iron"
                    secondTitle = "Milling"
               />
        } else if(selectedTwo==="drilling") {
            card = <MachineCard
                    firstTitle = "Cast Iron"
                    secondTitle = "Drilling"
               />
        } else if(selectedTwo==="superfinishing") {
            card = <MachineCard
                    firstTitle = "Cast Iron"
                    secondTitle = "Superfinishing"
               />
        }   
    } else if(selectedOne==="aluminium"){
        if(selectedTwo==="broaching"){
            card = <MachineCard
                    firstTitle = "Aluminium"
                    secondTitle = "Broaching"
               />
        } else if(selectedTwo==="deepDrilling") {
            card = <MachineCard
                    firstTitle = "Aluminium"
                    secondTitle = "Deep Drilling"
               />
        } else if(selectedTwo==="grinding") {
            card = <MachineCard
                    firstTitle = "Aluminium"
                    secondTitle = "Grinding"
               />
        } else if(selectedTwo==="milling") {
            card = <MachineCard
                    firstTitle = "Aluminium"
                    secondTitle = "Milling"
               />
        } else if(selectedTwo==="drilling") {
            card = <MachineCard
                    firstTitle = "Aluminium"
                    secondTitle = "Drilling"
               />
        } else if(selectedTwo==="superfinishing") {
            card = <MachineCard
                    firstTitle = "Aluminium"
                    secondTitle = "Superfinishing"
               />
        } 
    } else if(selectedOne==="highAlloySteel"){
        if(selectedTwo==="broaching"){
            card = <MachineCard
                    firstTitle = "High Alloy Steel  / Stainless Steel"
                    secondTitle = "Broaching"
               />
        } else if(selectedTwo==="deepDrilling") {
            card = <MachineCard
                    firstTitle = "High Alloy Steel  / Stainless Steel"
                    secondTitle = "Deep Drilling"
               />
        } else if(selectedTwo==="grinding") {
            card = <MachineCard
                    firstTitle = "High Alloy Steel  / Stainless Steel"
                    secondTitle = "Grinding"
               />
        } else if(selectedTwo==="milling") {
            card = <MachineCard
                    firstTitle = "High Alloy Steel  / Stainless Steel"
                    secondTitle = "Milling"
               />
        } else if(selectedTwo==="drilling") {
            card = <MachineCard
                    firstTitle = "High Alloy Steel  / Stainless Steel"
                    secondTitle = "Drilling"
               />
        } else if(selectedTwo==="superfinishing") {
            card = <MachineCard
                    firstTitle = "High Alloy Steel  / Stainless Steel"
                    secondTitle = "Superfinishing"
               />
        } 
    } else if(selectedOne==="yellowMetal"){
        if(selectedTwo==="broaching"){
            card = <MachineCard
                    firstTitle = "Yellow Metal"
                    secondTitle = "Broaching"
               />
        } else if(selectedTwo==="deepDrilling") {
            card = <MachineCard
                    firstTitle = "Yellow Metal"
                    secondTitle = "Deep Drilling"
               />
        } else if(selectedTwo==="grinding") {
            card = <MachineCard
                    firstTitle = "Yellow Metal"
                    secondTitle = "Grinding"
               />
        } else if(selectedTwo==="milling") {
            card = <MachineCard
                    firstTitle = "Yellow Metal"
                    secondTitle = "Milling"
               />
        } else if(selectedTwo==="drilling") {
            card = <MachineCard
                    firstTitle = "Yellow Metal"
                    secondTitle = "Drilling"
               />
        } else if(selectedTwo==="superfinishing") {
            card = <MachineCard
                    firstTitle = "Yellow Metal"
                    secondTitle = "Superfinishing"
               />
        } 
    } else if(selectedOne==="lowAlloySteel"){
        if(selectedTwo==="broaching"){
            card = <MachineCard
                    firstTitle = "Low/Med Alloy Steel"
                    secondTitle = "Broaching"
               />
        } else if(selectedTwo==="deepDrilling") {
            card = <MachineCard
                    firstTitle = "Low/Med Alloy Steel"
                    secondTitle = "Deep Drilling"
               />
        } else if(selectedTwo==="grinding") {
            card = <MachineCard
                    firstTitle = "Low/Med Alloy Steel"
                    secondTitle = "Grinding"
               />
        } else if(selectedTwo==="milling") {
            card = <MachineCard
                    firstTitle = "Low/Med Alloy Steel"
                    secondTitle = "Milling"
               />
        } else if(selectedTwo==="drilling") {
            card = <MachineCard
                    firstTitle = "Low/Med Alloy Steel"
                    secondTitle = "Drilling"
               />
        } else if(selectedTwo==="superfinishing") {
            card = <MachineCard
                    firstTitle = "Low/Med Alloy Steel"
                    secondTitle = "Superfinishing"
               />
        } 
    } else if(selectedOne==="otherAlloys"){
        if(selectedTwo==="broaching"){
            card = <MachineCard
                    firstTitle = "Other Alloys"
                    secondTitle = "Broaching"
               />
        } else if(selectedTwo==="deepDrilling") {
            card = <MachineCard
                    firstTitle = "Other Alloys"
                    secondTitle = "Deep Drilling"
               />
        } else if(selectedTwo==="grinding") {
            card = <MachineCard
                    firstTitle = "Other Alloys"
                    secondTitle = "Grinding"
               />
        } else if(selectedTwo==="milling") {
            card = <MachineCard
                    firstTitle = "Other Alloys"
                    secondTitle = "Milling"
               />
        } else if(selectedTwo==="drilling") {
            card = <MachineCard
                    firstTitle = "Other Alloys"
                    secondTitle = "Drilling"
               />
        } else if(selectedTwo==="superfinishing") {
            card = <MachineCard
                    firstTitle = "Other Alloys"
                    secondTitle = "Superfinishing"
               />
        } 
    }

    return (
        <div className="mt-5">

            <Row>
                <Col xs={2}>
                </Col>
                <Col xs={4}>
                    <Select
                        options={optionsOne}
                        onChange={value => changeSelectedOne(value)}
                        defaultValue={{ value: "", label: "Choose" }}
                    />
                </Col>
                <Col xs={4}>
                    <Select
                        options={optionsTwo}
                        onChange={value => changeSelectedTwo(value)}
                        defaultValue={{ value: "", label: "Choose" }}
                    />
                </Col>
                <Col xs={2}>
                </Col>
            </Row>  

            <Row className="d-flex justify-content-center align-items-center mt-4" >
                {
                    isShow?

                        <Col xs={8}>
                            {card}
                        </Col>
                            
 
                    :
                        null
                }
            </Row>
            
        </div>
    )
}
export default Index;